import classNames from 'classnames';
import { FunctionComponent } from 'react';

import { LINK_CLASS } from 'src/constants';
import { THEME } from 'src/enums/theme';
import ChevronDownIcon from 'src/icons/chevron-down.svg';
import ChevronUpIcon from 'src/icons/chevron-up.svg';
import utilStyles from 'src/styles/_utility.scss';

import styles from './Parent.module.scss';

export type ParentStyleVariant = 'primary' | 'secondary';

interface ParentProps {
  text: string;
  isExpanded: boolean;
  styleVariant?: ParentStyleVariant;
  theme?: THEME;
  onClick: () => void;
}

export const Parent: FunctionComponent<ParentProps> = ({
  isExpanded,
  onClick,
  text,
  styleVariant = 'primary',
  theme = THEME.LIGHT,
}) => {
  const buttonStyles = classNames(styles.parent, styles[theme], LINK_CLASS, {
    [styles.buttonSecondary]: styleVariant === 'secondary',
    [styles.isExpanded]: isExpanded,
  });

  const iconStyles = classNames(styles.parentIcon, styles[theme], {
    [styles.iconSecondary]: styleVariant === 'secondary',
    [styles.isExpanded]: isExpanded,
  });

  return (
    <button className={buttonStyles} onClick={onClick} type="button">
      <span className={utilStyles.noWrap}>{text}</span>

      <span className={utilStyles.noWrap}>
        {isExpanded ? <ChevronUpIcon className={iconStyles} /> : <ChevronDownIcon className={iconStyles} />}
      </span>
    </button>
  );
};
